import React from 'react'
import OffLine from '../off-line'

const OffLineEn = () => {
    return <OffLine languageCode="en" />
}

export default OffLineEn
